<div data-testid="c360" class="c360">
  <header data-testid="c360-header" class="c360__head">
    <div class="c360__title-row">
      <h1 data-testid="c360-name" class="c360__name">{{ data?.Insight?.companyName || companyId }}</h1>
      <span *ngIf="data?.Insight && data.Insight.healthScore !== null" data-testid="c360-health" class="adb-tier-badge"
            [attr.data-tier]="data.Insight.tier || 'healthy'">{{ tierLabel(data.Insight.tier) }} · {{ data.Insight.healthScore }}</span>
      <span *ngFor="let flag of data?.Insight?.flags ?? []" data-testid="c360-flag-chip" class="c360__chip">{{ flag.label }}</span>
      <button mat-stroked-button type="button" data-testid="c360-copy-link" class="c360__copy adb-natural-width" (click)="copyLink()">
        <i class="fa-regular fa-link" aria-hidden="true"></i> {{ copyLabel }}
      </button>
    </div>
    <p data-testid="c360-meta" class="c360__meta">
      <ng-container *ngIf="metaLine !== null; else r4Meta">{{ metaLine }}</ng-container>
      <ng-template #r4Meta>
        {{ companyId }} · <span data-testid="c360-client-badge">{{ data?.Insight?.isClient ? 'Client' : 'Not in Client Manager' }}</span>
        <ng-container *ngIf="data?.Insight"> · as of {{ data.Insight.date | date:'d MMM y':'UTC' }}</ng-container>
      </ng-template>
    </p>
    <p *ngIf="data?.Insight?.flags?.length" data-testid="c360-reasons" class="c360__reasons">
      <span *ngFor="let flag of data.Insight.flags" data-testid="c360-reason"><b>{{ flag.label }}:</b> {{ flag.reason }}</span>
    </p>
  </header>
  <app-admin-dashboard-empty *ngIf="data && !data.Insight" data-testid="c360-no-insight" icon="fa-regular fa-heart-pulse"
                             [title]="'No predictions yet for this company'"
                             [body]="'The nightly job has not scored this company yet. Its engagement, commercial and product use still show below.'"></app-admin-dashboard-empty>
  <section *ngIf="kpis.length" data-testid="c360-kpis" class="c360-kpis" aria-label="Account at a glance">
    <app-admin-dashboard-kpi-tile *ngFor="let kpi of kpis" [kpi]="kpi"></app-admin-dashboard-kpi-tile>
  </section>
  <div data-testid="c360-sections" class="c360__sections">
    <app-admin-dashboard-c360-timeline [companyId]="companyId" (healthLoaded)="onHealthLoaded($event)"></app-admin-dashboard-c360-timeline>
    <app-admin-dashboard-c360-engagement [companyId]="companyId"></app-admin-dashboard-c360-engagement>
    <app-admin-dashboard-c360-commercial *ngIf="granted('APClientManager') || granted('APBilling')" [companyId]="companyId"
                                         [licencesGranted]="granted('APClientManager')"
                                         [billingGranted]="granted('APBilling')"></app-admin-dashboard-c360-commercial>
    <!-- GEN-E-182-27: Product use follows the Usage Report app's feature, APUsageReport. -->
    <app-admin-dashboard-c360-product-use *ngIf="granted('APUsageReport')" [companyId]="companyId"></app-admin-dashboard-c360-product-use>
  </div>
</div>
